import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { css, ThemedCssFunction } from "styled-components";

const polyfillCss: ThemedCssFunction<BaseTheme> = (first: any, ...interpolations: any): any => {
    return css`
        ${x => css(first, ...interpolations).map(y => (typeof y === "function" ? (y as any)(x) : y))}
    `;
};

export default polyfillCss;
